/** .badge-active / -paused / -archived / -new / -win / -wire / -crypto */
export default function Badge({ kind = 'active', className = '', children, ...rest }) {
  return <span className={['badge', `badge-${kind}`, className].filter(Boolean).join(' ')} {...rest}>{children}</span>;
}
